import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jt_up",
  "use": "icon-jt_up-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-jt_up\">\r\n  <path id=\"icon-jt_up_路径_6066\" data-name=\"路径 6066\" d=\"M10,20A10,10,0,1,0,0,10,9.976,9.976,0,0,0,10,20ZM6.375,10.042H9.167V6.708a.833.833,0,1,1,1.667,0v3.333h2.792a.224.224,0,0,1,.167.375l-3.625,3.625a.252.252,0,0,1-.333,0L6.208,10.417a.224.224,0,0,1,.167-.375Z\" transform=\"translate(20 20) rotate(180)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol